module.exports = __webpack_public_path__ + "media/bootstrap-icons/cash-stack-dfc5c209.svg";